import React, { useState } from "react";
import { TbDownload, TbBrandGithub, TbShieldCheck, TbChevronDown } from "react-icons/tb";
import { CURRENT_RELEASE, PREVIOUS_RELEASES } from "../../lib/releases";
import { Button, Chip } from "../../components";
import "./DownloadsScreen.css";

// Downloads. No API calls: the release list is static data, lifted into lib/releases.js
// so it is edited in one place rather than inside a component's render.
const DownloadsScreen = () => {
  const [showPrevious, setShowPrevious] = useState(false);

  return (
    <div className="v2-page">
      <div className="v2-pagehead">
        <div>
          <h2>Download the scanner</h2>
          <p>Run it on a machine inside the network, then bring the JSON back here.</p>
        </div>
      </div>

      <div className="v2-release">
        <div className="v2-release-head">
          <div>
            <div className="v2-release-version">Version {CURRENT_RELEASE.version}</div>
            <div className="v2-release-date">Released {CURRENT_RELEASE.date}</div>
          </div>
          <Chip>Current</Chip>
          <Button variant="primary" as="a" onClick={() => window.open(CURRENT_RELEASE.s3Url, "_blank", "noopener")}>
            <TbDownload size={15} /> Download
          </Button>
        </div>

        <dl className="v2-release-meta">
          <div>
            <dt>SHA-256</dt>
            <dd className="v2-mono">{CURRENT_RELEASE.sha256}</dd>
          </div>
        </dl>

        <div className="v2-release-links">
          {CURRENT_RELEASE.githubUrl && (
            <a href={CURRENT_RELEASE.githubUrl} target="_blank" rel="noreferrer noopener">
              <TbBrandGithub size={14} /> Source on GitHub
            </a>
          )}
          {CURRENT_RELEASE.virusTotalUrl && (
            <a href={CURRENT_RELEASE.virusTotalUrl} target="_blank" rel="noreferrer noopener">
              <TbShieldCheck size={14} /> VirusTotal scan
            </a>
          )}
        </div>
      </div>

      {PREVIOUS_RELEASES.length > 0 && (
        <div className="v2-prev">
          <button type="button" className="v2-prev-toggle" onClick={() => setShowPrevious((s) => !s)} aria-expanded={showPrevious}>
            <TbChevronDown size={15} style={{ transform: showPrevious ? "rotate(0deg)" : "rotate(-90deg)", transition: "transform .15s ease" }} />
            Previous releases ({PREVIOUS_RELEASES.length})
          </button>
          {showPrevious && (
            <div className="v2-tablewrap" style={{ marginTop: ".5rem" }}>
              <table className="v2-table">
                <thead>
                  <tr><th>Version</th><th>Released</th><th className="v2-num">Download</th></tr>
                </thead>
                <tbody>
                  {PREVIOUS_RELEASES.map((r) => (
                    <tr key={r.version}>
                      <td>{r.version}</td>
                      <td className="v2-dim">{r.date}</td>
                      <td className="v2-num">
                        <Button icon title={`Download ${r.version}`} onClick={() => window.open(r.s3Url, "_blank", "noopener")}>
                          <TbDownload size={15} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DownloadsScreen;
